import type { OpportunitySignals, OpportunityMultiTfState } from '../services/signalsService'
import { computeEntryRangeInfo } from './entryRange'

type MultiState = OpportunityMultiTfState['state'] | undefined

export function shouldShowMultiTfCriticalWarning(params: {
  multiTfState?: MultiState
  signals: OpportunitySignals | null
  lastPrice: number | null
}): boolean {
  const { multiTfState, signals, lastPrice } = params

  if (multiTfState !== 'error') return false
  if (!signals) return false
  if (lastPrice == null || !Number.isFinite(lastPrice)) return false

  const info = computeEntryRangeInfo(signals)
  if (!info.hasEntryRange) return false

  const stop =
    signals.stopPrice ?? signals.stopAggressive ?? signals.stopConservative ?? null

  const entryFrom = info.entryFrom
  const entryTo = info.entryTo

  if (entryFrom == null || entryTo == null) return false

  const isLong = signals.side === 'long'

  // Para Long:
  // - Faixa de entrada vai do valor mais alto (entryFrom) para o mais baixo (entryTo)
  // - Stop fica abaixo da faixa.
  // Consideramos zona crítica desde o topo da entrada até o stop.
  if (isLong) {
    const zoneTop = Math.max(entryFrom, entryTo)
    const effectiveStop = stop != null ? stop : entryTo
    const criticalMin = Math.min(effectiveStop, zoneTop)
    const criticalMax = zoneTop

    if (lastPrice <= criticalMax && lastPrice >= criticalMin) {
      return true
    }
    return false
  }

  // Para Short:
  // - Faixa de entrada vai do valor mais baixo (entryFrom) para o mais alto (entryTo)
  // - Stop fica acima da faixa.
  // Consideramos zona crítica desde a base da entrada até o stop.
  const zoneBottom = Math.min(entryFrom, entryTo)
  const effectiveStop = stop != null ? stop : entryTo
  const criticalMin = zoneBottom
  const criticalMax = Math.max(effectiveStop, zoneBottom)

  if (lastPrice >= criticalMin && lastPrice <= criticalMax) {
    return true
  }

  return false
}
